import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const mailboxCreateFormStyles = StyleSheet.create({
	// Applied alongside the shared `settingsStyles.formCard` to keep the create form narrow.
	narrow: {
		maxWidth: 560,
	},
	forbiddenNotice: {
		padding: '10px 12px',
		marginBottom: 12,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.main,
		border: `1px solid ${THEME.colors.border.light}`,
		fontSize: 13,
		color: THEME.colors.text.main,
	},
	errorMsg: {
		marginBottom: 12,
		fontSize: 13,
		color: THEME.colors.danger.main,
	},
});
